import { Alert, AlertTitle, Button } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'

/**
 * True when the signed-in user is partner staff whose partner licence is inactive.
 * (Only partner admins reach the app while suspended — end users are blocked at login.)
 */
export function useIsPartnerSuspended() {
    const { user } = useAuth()
    return Boolean(user?.isPartnerStaff && user?.partner && user.partner.is_license_active === false)
}

export default function PartnerSuspendedBanner() {
    const { user } = useAuth()
    const suspended = useIsPartnerSuspended()
    if (!suspended) {
        return null
    }
    return (
        <Alert
            severity="warning"
            square
            sx={{ borderRadius: 0 }}
            action={
                <Button color="inherit" size="small" component={RouterLink} to="/partner">
                    Partner console
                </Button>
            }
        >
            <AlertTitle>Partner account suspended</AlertTitle>
            Your partner account ({user.partner.name}) is suspended, so organisation dashboards
            are unavailable. You can still review your licence and branding on the Partner
            Console. Contact your platform administrator to reactivate.
        </Alert>
    )
}
